var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackwordArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70696 13.7929C9.09748 14.1834 9.09748 14.8166 8.70696 15.2071C8.31643 15.5976 7.68327 15.5976 7.29274 15.2071L1.49985 9.41421C0.718801 8.63317 0.718799 7.36684 1.49985 6.58579L7.29274 0.792894C7.68327 0.402369 8.31643 0.402369 8.70696 0.792894C9.09748 1.18342 9.09748 1.81658 8.70696 2.20711L3.91406 7H17.9998C18.5521 7 18.9998 7.44772 18.9998 8C18.9998 8.55229 18.5521 9 17.9998 9H3.91406L8.70696 13.7929Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackwordArrow);
export default __webpack_public_path__ + "static/media/Backword_Arrow.4d4daeb5d8d08c9e1b2f2bc98917e391.svg";
export { ForwardRef as ReactComponent };